// LeftSection.jsx
import React from 'react';

const ServiceImageSection = ({ title, description, images }) => (
  <div className="flex flex-col items-center md:items-start w-full md:w-1/2">
    <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-5xl font-bold mb-2 text-center md:text-left">
      {title}
    </h2>
    <p className="text-[#242B33] text-sm lg:text-lg mb-6 text-center md:text-left">
      {description}
    </p>
    {/* Images wrapper */}
    <div className="relative w-full max-w-[360px] sm:max-w-[420px] md:max-w-[450px] aspect-[4/3]">
      {/* Card 1 */}
      <div className="absolute inset-0 mt-2 md:mt-3 w-[78%] h-[78%] border-8 border-white rounded-tl-[30px] rounded-br-[30px] shadow-md overflow-hidden">
        <img src={images[0].src} alt={images[0].alt} className="w-full h-full object-cover rounded-tl-[30px] rounded-br-[30px]" />
      </div>
      {/* Card 2 */}
      <div className="
        absolute bottom-2 right-2 md:bottom-0 md:right-0 md:mb-3
        w-[65%] h-[62%]
        border-8 border-white rounded-tl-[30px] rounded-br-[30px] shadow-md overflow-hidden
        md:translate-x-2 md:translate-y-2
      ">
        <img src={images[1].src} alt={images[1].alt} className="w-full h-full object-cover rounded-tl-[30px] rounded-br-[30px]" />
      </div>
    </div>
  </div>
);

export default ServiceImageSection;
